// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import './index.css';
import App from './App'; // App コンポーネントをインポート
import { inject } from '@vercel/analytics';

const isVercelAnalyticsEnabled =
  process.env.NODE_ENV === 'production' &&
  process.env.REACT_APP_DISABLE_VERCEL_ANALYTICS !== 'true';

if (isVercelAnalyticsEnabled) {
  inject();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // ★ Provider の内側で App コンポーネントをレンダリングするだけにする
  <Provider store={store}>
    <App />
  </Provider>
);
